<template>
  <span v-if="planting">
    <span v-if="small" class="text-truncate product-text">
      <small>
        <v-avatar size="14" :color="planting.colorHex" class="mr-1"></v-avatar>
        {{ getDisplayText() }}
      </small>
    </span>
    <span v-else class="text-truncate">
      <v-avatar size="24" :color="planting.colorHex" class="mr-1"></v-avatar>
      {{ getDisplayText() }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'PlantingIndicatorComponent',
  props: {
    small: {
      type: [Boolean, String],
      required: false,
      default: false,
    },
    circleIconLarge: {
      type: Boolean,
      required: false,
      default: false,
    },
    planting: {
      type: Object,
    },
    displayYear: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {},
  methods: {
    getDisplayText() {
      const opts = { includeYear: this.$props.displayYear }
      return this.$props.planting.getLongDisplayText(opts)
    },
  },
}
</script>
